import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditPlan from "../components/plans/EditPlan";

const EditPlanPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Edit Plan' />

                <EditPlan />

            </MasterLayout>
        </>
    );
};

export default EditPlanPage;
